// extracted by mini-css-extract-plugin
module.exports = {"input":"_5df40","active":"c5448"};